export default function OnlyWithFunds({ children, active, funds }) {
  return active && !funds ? null : children;
}
